//imports
import {
    UNIT_TYPE_EVENTS_OPEN_MODAL,
    UNIT_TYPE_EVENTS_SEARCH_REQUEST,
    UNIT_TYPE_EVENTS_SEARCH_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    fromData: null,
    unitTypeEvents: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case UNIT_TYPE_EVENTS_SEARCH_REQUEST:
            return { ...state, loading: true }

        case UNIT_TYPE_EVENTS_SEARCH_RESULT:
            return { ...state, loading: false, unitTypeEvents: action.payload.items }

        case CLEAR_REDUX:
            return ["", "UNIT_TYPE_EVENTS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};